import React, { memo } from 'react'

import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'
import I18n from 'Pods/Shared/I18n'

const translate = (key) => I18n.t(key, { ns: 'rails' })

function Categories() {
  // Placeholder dropdown; its contents are defined in a follow-up subtask.
  const content = (
    <div className="secondary-filters__dropdown-placeholder cgt-body-base">
      {translate('search_page.filters.under_construction')}
    </div>
  )

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.categories.title')}
      content={content}
      positionHorizontal="right"
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(Categories)
